import React, { useState, useEffect } from "react"
import { withOutScript } from "../../../shared/utils/formatString"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"
// import {navigate } from "gatsby"

import "./aside-mobile-list-subcategory.scss"

const AsideMobileListSubcategory = props => {
  const { listSubCategories, currentSubcategory, setModalActive } = props

  const [curtain, setCurtain] = useState(false)

  useEffect(() => {
    setCurtain(true)
    setCurtain(true)
    document.body.style.overflow = "hidden"
  }, [])

  const handleRedirect = fullSlug => {
    handleClose()
    setTimeout(() => {
      window.location.href = "/productos" + removeDoubleSlash(fullSlug)
    }, 200)
  }

  const handleClose = () => {
    setCurtain(false)

    setTimeout(() => {
      setModalActive(null)
    }, 200)
  }

  const userInfoEncrypt= encryptUserInfo()
  return (
    <aside
      className={"f-aside-nav-products " + (curtain ? "f-active-curtain" : "")}
    >
      <div
        className={
          "f-elements-container " + (curtain ? "f-elements-active" : "")
        }
      >
        <p className="f-aside-nav-copy">Otros Productos</p>
        <ul className="f-nav-content">
          {listSubCategories.map((subcategory, index) => {
            if (currentSubcategory === subcategory.slug) {
              return null
            } else {
              return (
                <li
                  className="f-item-subcategory"
                  key={index}
                  onClick={() =>{
                    pushDataLayerEvent({
                      event: "Interacciones - Filtro",
                      category: withOutScript(currentSubcategory),
                      sub_category: 'Otros productos',
                      action: "click",
                      label: subcategory.titulo,
                      location: window.location.href,
                      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                      log_status: userInfoEncrypt.log_status,
                    })

                    handleRedirect(
                      "/" + subcategory.categoria + "/" + subcategory.slug
                    )
                  }}
                >
                  {subcategory.titulo}
                </li>
              )
            }
          })}
          <span
            className="f-icon icon2-close f-icon-close"
            onClick={() => handleClose()}
          />
        </ul>
      </div>
    </aside>
  )
}

export default AsideMobileListSubcategory
